import(/* webpackMode: "eager", webpackExports: ["HydrationBoundary"] */ "/app/node_modules/@tanstack/react-query/build/modern/HydrationBoundary.js");
;
import(/* webpackMode: "eager", webpackExports: ["IsRestoringProvider","useIsRestoring"] */ "/app/node_modules/@tanstack/react-query/build/modern/IsRestoringProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@tanstack/react-query/build/modern/QueryClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["QueryErrorResetBoundary","useQueryErrorResetBoundary"] */ "/app/node_modules/@tanstack/react-query/build/modern/QueryErrorResetBoundary.js");
;
import(/* webpackMode: "eager", webpackExports: ["useInfiniteQuery"] */ "/app/node_modules/@tanstack/react-query/build/modern/useInfiniteQuery.js");
;
import(/* webpackMode: "eager", webpackExports: ["useIsFetching"] */ "/app/node_modules/@tanstack/react-query/build/modern/useIsFetching.js");
;
import(/* webpackMode: "eager", webpackExports: ["useMutation"] */ "/app/node_modules/@tanstack/react-query/build/modern/useMutation.js");
;
import(/* webpackMode: "eager", webpackExports: ["useIsMutating","useMutationState"] */ "/app/node_modules/@tanstack/react-query/build/modern/useMutationState.js");
;
import(/* webpackMode: "eager", webpackExports: ["useQueries"] */ "/app/node_modules/@tanstack/react-query/build/modern/useQueries.js");
;
import(/* webpackMode: "eager", webpackExports: ["useQuery"] */ "/app/node_modules/@tanstack/react-query/build/modern/useQuery.js");
;
import(/* webpackMode: "eager", webpackExports: ["useSuspenseInfiniteQuery"] */ "/app/node_modules/@tanstack/react-query/build/modern/useSuspenseInfiniteQuery.js");
;
import(/* webpackMode: "eager", webpackExports: ["useSuspenseQueries"] */ "/app/node_modules/@tanstack/react-query/build/modern/useSuspenseQueries.js");
;
import(/* webpackMode: "eager", webpackExports: ["useSuspenseQuery"] */ "/app/node_modules/@tanstack/react-query/build/modern/useSuspenseQuery.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["HeroVideo"] */ "/app/src/components/storefront/blocks/hero-video.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NewsletterForm"] */ "/app/src/components/storefront/blocks/newsletter-form.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductsGrid"] */ "/app/src/components/storefront/blocks/products-grid.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PromoCountdown"] */ "/app/src/components/storefront/blocks/promo-countdown.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PromoDismiss"] */ "/app/src/components/storefront/blocks/promo-dismiss.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RecentlyViewedClient"] */ "/app/src/components/storefront/blocks/recently-viewed-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TestimonialsCarousel"] */ "/app/src/components/storefront/blocks/testimonials-carousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BreadcrumbTrail"] */ "/app/src/components/storefront/breadcrumb-trail.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ContactForm"] */ "/app/src/components/storefront/contact-form.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/i18n/provider.tsx");
